import BaseService from 'services/BaseService';
import moment from 'moment';

//-------------------------------------------------------------------------------------------------------------------

export default class OnboardingService
    extends BaseService {

    static async sendWelcomeEmail(instructorID) {
        return BaseService.postFile('onboarding/send-welcome-email/' + instructorID);
    }

    static async get(id) {
        return BaseService.callAPI('onboarding/get/' + (id || ''));
    }

    static async update(fieldName, value) {
        return BaseService.callAPI('onboarding/update', {
            fieldName, value
        });
    }

    static async submit(newPassword) {
        return BaseService.callAPI('onboarding/submit', { newPassword });
    }

    static async approve(instructorID) {
        return BaseService.callAPI('onboarding/approve/' + instructorID);
    }

    static async skip(instructorID) {
        return BaseService.callAPI('onboarding/skip/' + instructorID);
    }

    static async listSteps(id) {
        return BaseService.callAPI('onboarding/list-steps/' + id);
    }

    static async updateStep(instructorID, onboardingStepID, field, value) {
        return BaseService.callAPI('onboarding/update-step/' + instructorID, {
            onboardingStepID,
            field,
            value
        });
    }

    //static async uploadEvidence(instructorID, onboardingStepID, file) {
    //    return BaseService.postFile('onboarding/upload-evidence', file, {
    //        instructorID,
    //        onboardingStepID
    //    });
    //}
}
